module.exports = __webpack_public_path__ + "img/attack_matrix.64a730ab.png";